const customerPayment = {
  customer_payments: `Pagos Del Cliente`,
  data_not_found_for_organization_id: `Datos no encontrados para el ID de la organización:{{orgId}}`,
  "Days Sales Outstanding Report":
    "Resumen de Días de Ventas Pendientes (Gráfico)",
  "Days Sales Outstanding Table":
    "Detalles de Días de Ventas Pendientes (Tabla)",
  "Customer Company ID": "ID de la Empresa Cliente",
  "Accounts Receivable at Period End":
    "Cuentas por Cobrar al Final del Período",
  "Total Credit Sales in Period": "Ventas Totales a Crédito en el Período",
  "Days Sales Outstanding": "Días de Ventas Pendientes",
  days_with_value: `{{value}} Dias`,
  dso: `DSO`,
};

export default customerPayment;
